import { api } from '@ui/store/baseApi';
import type { Session } from '@ui/store/types';

/** Sign-in and session endpoints, used by both the customer app and the admin panel. */
export const authApi = api.injectEndpoints({
  endpoints: (b) => ({
    me: b.query<Session, void>({ query: () => '/auth/me', providesTags: ['Session'] }),
    login: b.mutation<Session, { email: string; password: string }>({ query: (body) => ({ url: '/auth/login', method: 'POST', body }), invalidatesTags: ['Session'] }),
    register: b.mutation<Session, Record<string, unknown>>({ query: (body) => ({ url: '/auth/register', method: 'POST', body }), invalidatesTags: ['Session'] }),
    logout: b.mutation<void, void>({ query: () => ({ url: '/auth/logout', method: 'POST' }) }),
    forgotPassword: b.mutation<{ message: string }, { email: string }>({ query: (body) => ({ url: '/auth/forgot-password', method: 'POST', body }) }),
    resetPassword: b.mutation<{ message: string }, { token: string; password: string }>({ query: (body) => ({ url: '/auth/reset-password', method: 'POST', body }) }),
    acceptInvite: b.mutation<Session, { token: string; firstName: string; lastName?: string; password: string }>({ query: (body) => ({ url: '/auth/accept-invitation', method: 'POST', body }), invalidatesTags: ['Session'] }),
    changePassword: b.mutation<{ message: string }, { currentPassword: string; newPassword: string }>({ query: (body) => ({ url: '/auth/change-password', method: 'POST', body }) }),
    updateProfile: b.mutation<Session, { firstName: string; lastName?: string }>({ query: (body) => ({ url: '/auth/me', method: 'PATCH', body }), invalidatesTags: ['Session'] }),
    switchOrg: b.mutation<Session, { organizationId: string }>({ query: (body) => ({ url: '/auth/switch-organization', method: 'POST', body }) }),
    exitOrg: b.mutation<Session, void>({ query: () => ({ url: '/auth/exit-organization', method: 'POST' }) })
  })
});

export const {
  useMeQuery,
  useLoginMutation,
  useRegisterMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useAcceptInviteMutation,
  useChangePasswordMutation,
  useUpdateProfileMutation,
  useSwitchOrgMutation,
  useExitOrgMutation
} = authApi;
